//#region src/core/source/twitch.ts
/**
* Extract a Twitch VOD id from any recognized video URL.
*
* @internal
*/
function parseTwitchVideoId(src) {
	return parseTwitchSource(src)?.id ?? null;
}
/**
* Parse a Twitch source string. Recognizes VOD URLs (`twitch.tv/videos/<id>` and `twitch.tv/?video=<id>`) and channel
* URLs (`twitch.tv/<channel>`), with or without the `www.` and `go.` hosts, and with or without a trailing slash.
*
* @internal
*/
function parseTwitchSource(src) {
	if (!src) return null;
	const videoId = MATCH_VIDEO.exec(src)?.[1];
	if (videoId) return {
		kind: "video",
		id: videoId,
		channel: null
	};
	const channel = MATCH_CHANNEL.exec(src)?.[1];
	if (channel) return {
		kind: "channel",
		id: null,
		channel
	};
	return null;
}
const MATCH_VIDEO = /(?:^|\/\/)(?:www\.|go\.)?twitch\.tv\/(?:videos?\/|\?video=)(\d+)\/?(?:$|\?)/;
const MATCH_CHANNEL = /(?:^|\/\/)(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)\/?(?:$|\?)/;
//#endregion
export { parseTwitchSource, parseTwitchVideoId };
